<template>
  <v-dialog
    width="600"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    v-model="opened"
    persistent
    @keydown.esc="$emit('update:opened', false)"
  >
    <v-card>
      <v-card-title class="title"
        >Review Return Details for
        {{ currentCompany.tax_return_name }}</v-card-title
      >
      <v-card-text v-if="loading || !clientDetailInfo">
        <v-progress-linear indeterminate color="primary" />
      </v-card-text>
      <v-card-text v-else>
        <v-layout
          v-for="field in clientDetailInfo.extracted_document_fields"
          :key="field.id"
        >
          <v-layout
            align-center
            v-if="field.value !== field.corrected_value"
            class="font-weight-bold error--text"
          >
            {{ field.label }}: {{ field.value
            }}<v-icon class="mx-1">arrow_right_alt</v-icon>
            {{ field.corrected_value }}
          </v-layout>
          <v-layout align-center v-else>
            {{ field.label }}: {{ field.corrected_value }}
          </v-layout>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="default-input text-capitalize primary"
          @click="scheduleForExport"
        >
          Schedule for Export
        </v-btn>
        <v-btn
          class="text-capitalize error--text"
          outline
          @click="$emit('update:opened', false)"
        >
          {{ $t('cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { rules } from '@/constants/variables';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import API from '@/api';

export default {
  components: {},

  props: {
    opened: {
      type: Boolean,
    },

    currentCompany: {
      type: Object,
    },
  },

  data() {
    return {
      rules,
      clientDetailInfo: null,
      loading: true,
    };
  },
  methods: {
    isEmpty,
    moment,
    async getExtractedDocument() {
      try {
        const response = await API.extractedDocument.getExtractedDocument({
          id: this.currentCompany.latest_update_export_task
            .extracted_document_id,
          companyId: this.currentCompany.id,
        });
        console.log(response);
        if (response.data.error) {
          console.log(response.data.error);
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
          });
        } else {
          this.clientDetailInfo = response.data;
          console.log(response);
        }
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message:
            'Something went wrong. Please refresh the page and try again.',
        });
      } finally {
        this.loading = false;
      }
    },
    async scheduleForExport() {
      try {
        this.currentCompany.latest_update_export_task.status = 'scheduled';
        const response = await API.exportTask.updateExportTask(
          this.currentCompany.latest_update_export_task,
        );
        console.log(response);
        if (response.data.error) {
          console.log(response.data.error);
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
          });
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: `Scheduled for ${moment(
              this.currentCompany.latest_update_export_task.updated_at,
            ).format('LL')}`,
          });
        }
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message:
            'Something went wrong. Please refresh the page and try again.',
        });
      } finally {
        this.loading = false;
        this.$emit('update:opened', false);
      }
    },
  },
  watch: {
    opened: {
      async handler(value) {
        if (value === true) {
          await this.getExtractedDocument();
        } else {
          this.clientDetailInfo = null;
          const query = Object.assign({}, this.$route.query);
          delete query.review_required;
          this.$router.replace({ query });
        }
      },
    },
  },
};
</script>
